import Header from './components/Header';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Home from './components/Home';
import About from './components/About';
import Competences from './components/Competences';

function App() {
  return (
		<div>
			<Header />
			<Home />
			<About />
			<Competences />
			<Projects />
			<Contact />
		</div>
  );
}

export default App; 